/**
 * @desc 查看接口同步信息
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.DataDimensionApiSyncResponseDto>;
export function request(
  params: API.appCenter.dimension.apiInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dimension/api/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
